export default {"src":"/encomendas-static/_next/static/media/appStore.ea26aaf2.svg","height":32,"width":96,"blurWidth":0,"blurHeight":0};